import {defineStore} from 'pinia';
import {ModuleBudgetChapterGrade} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import budgetChapterGradeAPI from '@/apis/di/budgetChapterGradeAPI';

const buChapterGradeStore = new BaseDictionaryStore(budgetChapterGradeAPI);

export const useBuChapterGradeStore = defineStore(ModuleBudgetChapterGrade, {
  state: () => ({
    ...buChapterGradeStore.state,
    _config: {
      key: 'budget_chapter_grade_id',
      code: 'budget_chapter_grade_code',
      table: 'di_budget_chapter_grade',
      moduleName: 'Bảng Mã cấp ngân sách',
      defaultSort: 'budget_chapter_grade_code',
      quickFollow: 'active',
    },
    moduleName: 'diBudgetChapterGrade',
  }),
  actions: {...buChapterGradeStore.action},
  getters: {...buChapterGradeStore.getters},
});
